module.exports = __webpack_public_path__ + "img/2.76c9e5a2.png";